import {
  TealiumEventExperimentGroup,
  IGetEventGroupProps,
  tealiumEventExperimentGroupPrefix,
  TealiumEventExperimentGroupCC,
} from '@4tn/core-audio-player-shared';

export class TealiumEventExperiment implements IGetEventGroupProps {
  private experiment_tests: string | null = null;

  private experiment_test_variant: string | null = null;

  private experiment_features: string | null = null;

  constructor({ experimentTests, experimentTestVariant, experimentFeatures }: TealiumEventExperimentGroupCC) {
    if (experimentTests) {
      this.experiment_tests = experimentTests;
    }
    if (experimentTestVariant) {
      this.experiment_test_variant = experimentTestVariant;
    }
    if (experimentFeatures) {
      this.experiment_features = experimentFeatures;
    }
  }

  public getEventGroupProps(): TealiumEventExperimentGroup {
    const groupKeys = Object.keys(this).filter((k) => k.startsWith(tealiumEventExperimentGroupPrefix));
    const eventGroupProps = groupKeys.reduce((o, k) => Object.assign(o, { [k]: this[k] }), {});
    return eventGroupProps as TealiumEventExperimentGroup;
  }
}
